import { useEffect, useState, useContext } from 'react';
import { WbSidebarConfigContext } from './config';

export const useResponsiveMobile = (): boolean => {
  const { sidebarConfig } = useContext(WbSidebarConfigContext);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Create media query based on sidebar config
    const mediaQuery = window.matchMedia(
      `(max-width: ${sidebarConfig.mobileBreakpoint - 1}px)`,
    );

    // Set initial value
    setIsMobile(mediaQuery.matches);

    // Create handler for changes
    const handleChange = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches);
    };

    // Add listener
    mediaQuery.addEventListener('change', handleChange);

    // Cleanup
    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, [sidebarConfig.mobileBreakpoint]);

  return isMobile;
};
